export const PARTICIPANT_NUMBER_LENGTH = 4;

export const isParticipantNumberLengthValid = (
  participantNumberValue: string,
) =>
  participantNumberValue.length === 0 ||
  participantNumberValue.length === PARTICIPANT_NUMBER_LENGTH;
